module.exports = __webpack_public_path__ + "images/help/video-preview-project-4c7029caa131c41e802c6f151a117a73.png";